import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PasskeyButton } from "./PasskeyButton";

interface Props {
  onClose: () => void;
  onConfirmed: () => void;
}

export const PasskeyModal = ({ onClose, onConfirmed }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={true} onClose={onClose} closeOnOverlayClick={false} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("Confirm with your passkey")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="6">
          <Text mb="4">{t("Your account is protected by a passkey. Confirm with it to save the change.")}</Text>
          <PasskeyButton purpose="Confirm" label={t("Use passkey")} w="full" colorScheme="teal" onSuccess={onConfirmed} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
